import { useState } from "react"

export const Range = (name, initialValue) => {

	const [value, setValue] = useState(initialValue);

	const handleRangeChange = (e) => {
		setValue(e.target.value);
	}

	return (
		<div className="range-input-container">
			<input
				type='range'
				min='1'
				max='100'
				step='1'
				name={name}
				value={value}
				onChange={handleRangeChange}
			/>
			{value}
		</div>
	)
}
